import ReactDOM from 'react-dom/client';
import App from './App';
import {BrowserRouter} from "react-router-dom";

import { PrimeReactProvider } from 'primereact/api';

import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.css';  
import './index.css';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <PrimeReactProvider>
      <BrowserRouter>
    <App />
    </BrowserRouter>
    </PrimeReactProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
